import { atom } from 'recoil';
import { Role } from 'states';

interface DBInfo {
  title: string;
  description?: string;
}

interface DBAccess {
  accessConfig: any;
  escapedAccessConfig: Role[];
}

interface DBLayout {
  layoutConfig: string;
}

interface DBFilter {
  visualConfig: string;
  showDateFilter: boolean;
}

interface DBConfig {
  dashboardConfig: string;
}

interface DBWidgetsConfig {
  widgetsConfig: string;
}

interface DashboardData {
  info: DBInfo;
  layout: DBLayout;
  filters: DBFilter;
  config: DBConfig;
  widgets: DBWidgetsConfig;
  access: DBAccess;
}

/** Whether a dashboard is on production (LIVE) or not (TEST). The API's value, so upper case. */
export type DashboardStatusValue = 'LIVE' | 'TEST';

export interface Dashboard {
  profile: string;
  id?: number;
  dashboardId: string;
  title: string;
  isPinned: boolean;
  type: string;
  data: DashboardData[];
  timestamp?: any;
  /** Absent when talking to an API that predates dashboard statuses. */
  status?: DashboardStatusValue;
}

export const dashboardsState = atom<Dashboard[]>({
  key: 'dashboards',
  default: [],
});

export const currentDashboardState = atom<Dashboard>({
  key: 'currentDashboard',
  default: {} as Dashboard,
});

export const updateDashboardItemState = atom<Dashboard[]>({
  key: 'updateDashboardItem',
  default: [],
});
